<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :viewBox="viewBox">
    <g fill="none" fill-rule="nonzero">
      <path
        fill="#3DD8D3"
        d="M26.59 12.96v2.16c0 3.768-1.17 6.774-3.51 9.018-2.34 2.244-5.31 3.366-8.91 3.366-3.912 0-7.158-1.26-9.738-3.78-2.58-2.52-3.87-5.616-3.87-9.288 0-3.672 1.278-6.78 3.834-9.324 2.556-2.544 5.682-3.816 9.378-3.816 2.352 0 4.506.528 6.462 1.584 1.956 1.056 3.474 2.448 4.554 4.176l-4.896 2.808C19.342 9 18.52 8.292 17.428 7.74s-2.322-.828-3.69-.828c-2.136 0-3.906.708-5.31 2.124-1.404 1.416-2.106 3.228-2.106 5.436 0 2.184.72 3.966 2.16 5.346 1.44 1.38 3.36 2.07 5.76 2.07 3.336 0 5.484-1.296 6.444-3.888h-6.732v-5.04H26.59zm7.884 7.2c.624 1.68 2.064 2.52 4.32 2.52 1.464 0 2.616-.456 3.456-1.368l4.32 2.484c-1.776 2.472-4.392 3.708-7.848 3.708-3.024 0-5.442-.9-7.254-2.7-1.812-1.8-2.718-4.068-2.718-6.804 0-2.712.894-4.974 2.682-6.786 1.788-1.812 4.086-2.718 6.894-2.718 2.616 0 4.794.906 6.534 2.718 1.74 1.812 2.61 4.074 2.61 6.786 0 .768-.072 1.488-.216 2.16h-12.78zm-.108-4.032h7.74c-.528-1.896-1.8-2.844-3.816-2.844-2.088 0-3.396.948-3.924 2.844zm26.712-1.944H57.37v6.372c0 .72.288 1.176.864 1.368.576.192 1.524.252 2.844.18V27c-3.432.36-5.808.03-7.128-.99-1.32-1.02-1.98-2.838-1.98-5.454v-6.372h-2.88V9h2.88V5.58l5.4-1.62V9h3.708v5.184z"
      />
      <path
        fill="#2A7CBF"
        d="M67.496 27V.72h5.4V27h-5.4zM81.824 6.48a3.089 3.089 0 0 1-2.268.936c-.888 0-1.65-.318-2.286-.954-.636-.636-.954-1.398-.954-2.286 0-.888.318-1.65.954-2.286.636-.636 1.398-.954 2.286-.954.888 0 1.65.318 2.286.954.636.636.954 1.398.954 2.286 0 .888-.324 1.656-.972 2.304zM76.856 27V9h5.4v18h-5.4zM96.764 8.496c1.92 0 3.522.66 4.806 1.98 1.284 1.32 1.926 3.144 1.926 5.472V27h-5.4V16.74c0-1.056-.294-1.866-.882-2.43-.588-.564-1.338-.846-2.25-.846-1.032 0-1.848.312-2.448.936-.6.624-.9 1.548-.9 2.772V27h-5.4V9h5.4v1.692c1.08-1.464 2.796-2.196 5.148-2.196zM124.484 27h-6.12l-5.76-7.956V27h-5.4V1.8h5.4v15.084l5.4-7.884h6.3l-6.552 9 6.732 9z"
      />
    </g>
  </svg>
</template>
<script>
  export default {
    name: 'icon-logo-name',
    props: {
      width: {
        type: [Number, String],
        default: 125
      },
      height: {
        type: [Number, String],
        default: 28
      },
      viewBox: {
        type: String,
        default: '0 0 125 28'
      }
    }
  };
</script>
